import axios from "utils/httpClient";
import { BehaviorSubject } from 'rxjs';
import { Route, withRouter, useHistory  } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
//import config from 'config';


const currentUserSubject = new BehaviorSubject((localStorage.getItem('currentUser') != '[object Object]') ? JSON.parse(localStorage.getItem('currentUser')) : [{}]);

export const authenticationService = {
    login,
    logout,
    currentUser: currentUserSubject.asObservable(),
    get currentUserValue () { return currentUserSubject.value }
};

function login(email, password) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        data: { email, password }
    };
    /*https://localhost:5001*/
    return axios('/api/v1/identity/login', requestOptions)
        .then(response => response.data)
        .then(user => {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            console.log(user);
            localStorage.setItem('currentUser', JSON.stringify(user));
            currentUserSubject.next(user);

            return user;
        });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    currentUserSubject.next(null);
    /*
    const { from } = this.props.location.state || { from: { pathname: "/login" } };
    this.props.history.push(from);
    this.props.history.push('/login');
    */
}
